import { STRATSYS_IDSRV } from '../app.constants';

export const STRATSYS_TENANT_ID_KEY = 'stratsysTenantIdKey';

export function buildOidcConfig({ authorityUrl, clientId }) {
    return {
        authority: authorityUrl,
        client_id: clientId,
        redirect_uri: window.location.protocol + '//' + window.location.host + '/oauthcallback.html',
        post_logout_redirect_uri: window.location.protocol + '//' + window.location.host + '/index.html',
        response_type: 'code',
        scope: 'openid profile email role meetings user.readwrite helpcenter platform.document.export.readwrite',
        silent_redirect_uri: window.location.protocol + '//' + window.location.host + '/frame.html',
        automaticSilentRenew: true,
        loadUserInfo: true,
        revokeAccessTokenOnSignout: true,
        popupWindowFeatures: 'location=no,toolbar=no,width=500,height=500,left=100,top=100'
    };
}

function getTenantId() {
    return window.localStorage.getItem(STRATSYS_TENANT_ID_KEY) || window.sessionStorage.getItem(STRATSYS_TENANT_ID_KEY);
}

function fetchAppSettings() {
    return fetch(window.location.origin + '/meetings_appsettings.v2.json')
        .then((resp) => resp.json())
        .catch(() => null);
}

// Resolves the OIDC config for standalone entry points (oauthcallback, silent.renew)
// that run outside Angular and cannot use envService / platformService.
export function resolveOidcConfig() {
    return fetchAppSettings().then((appSettings) => {
        const idsrv = (appSettings && appSettings.STRATSYS_IDSRV) || {};
        const authorityBase = idsrv.URL || STRATSYS_IDSRV.NEW;
        const clientId = idsrv.CLIENT_ID || STRATSYS_IDSRV.CLIENT_ID;
        const tenantId = getTenantId() || '';

        return buildOidcConfig({
            authorityUrl: authorityBase + tenantId,
            clientId: clientId
        });
    });
}
